import { useMemo } from 'react';

import { useReportContext } from '@/context/ReportContext';

const convertToDateString = (date: Date): string => {
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const usePanelInsightsFilters = () => {
  const { filters } = useReportContext();
  const formattedFromDate = convertToDateString(filters.selectedDates?.from);
  const formattedToDate = convertToDateString(filters.selectedDates?.to);
  const dataQueryString = useMemo(() => {
    if (
      filters?.selectedPanelsForComparison &&
      formattedFromDate &&
      formattedToDate &&
      filters?.selectedInterval
    ) {
      const params = new URLSearchParams();
      filters.selectedPanelsForComparison.forEach((panel) =>
        params.append('panel_ids', panel)
      );
      params.append('from_date', formattedFromDate);
      params.append('to_date', formattedToDate);
      params.append('time_interval', filters.selectedInterval);
      return params.toString();
    }
  }, [
    filters.selectedInterval,
    filters.selectedPanelsForComparison,
    formattedFromDate,
    formattedToDate,
  ]);

  return {
    dataQueryString,
  };
};
